/* @flow */
import * as React from 'react';
import { GlobalTimezoneDropdown } from 'common/modules/timezone';

class PersonnelLocaleSettings extends React.PureComponent<{}> {
    render() {
        return <GlobalTimezoneDropdown />;
    }
}

export default PersonnelLocaleSettings;
